import classNames from 'classnames';
import { DataTable as PrimeReactDataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { IDataTableProps } from './DataTable.types';

import './data-table.scss';

export default function DataTable({
  value,
  dataKey,
  header,
  footer,
  size,
  showGridlines,
  stripedRows,
  paginator,
  rowsPerPageOptions,
  paginatorTemplate,
  currentPageReportTemplate,
  paginatorLeft,
  paginatorRight,
  rows,
  sortMode,
  sortField,
  sortOrder,
  removableSort,
  emptyMessage,
  selectionMode,
  selection,
  dragSelection,
  metaKeySelection,
  expandedRows,
  editMode,
  isDataSelectable,
  showSelectionElement,
  onSelectionChange,
  onRowSelect,
  onRowUnselect,
  onRowExpand,
  onRowCollapse,
  onRowToggle,
  rowClassName,
  rowExpansionTemplate,
  onRowEditComplete,
  frozenValue,
  scrollable,
  scrollHeight,
  resizableColumns,
  columnResizeMode,
  reorderableColumns,
  reorderableRows,
  onRowReorder,
  headerColumnGroup,
  tableStyle,
  columns,
  className,
  onRowClick,
}: IDataTableProps) {
  // The count now sits under the table with the pages, so the header bar only
  // appears for a page that has something to put in it.
  const tableHeader = header || undefined;
  return (
    <PrimeReactDataTable
      value={value}
      dataKey={dataKey}
      header={tableHeader}
      footer={footer}
      showGridlines={showGridlines}
      stripedRows={stripedRows}
      paginator={paginator}
      rowsPerPageOptions={rowsPerPageOptions}
      paginatorTemplate={paginatorTemplate}
      currentPageReportTemplate={currentPageReportTemplate}
      paginatorLeft={paginatorLeft}
      paginatorRight={paginatorRight}
      rows={rows}
      size={size}
      sortMode={sortMode}
      sortField={sortField}
      sortOrder={sortOrder}
      removableSort={removableSort}
      emptyMessage={emptyMessage}
      selectionMode={selectionMode}
      selection={selection}
      dragSelection={dragSelection}
      metaKeySelection={metaKeySelection}
      expandedRows={expandedRows}
      editMode={editMode}
      isDataSelectable={isDataSelectable}
      showSelectionElement={showSelectionElement}
      onSelectionChange={onSelectionChange}
      onRowSelect={onRowSelect}
      onRowUnselect={onRowUnselect}
      onRowExpand={onRowExpand}
      onRowCollapse={onRowCollapse}
      onRowToggle={onRowToggle}
      rowClassName={rowClassName}
      rowExpansionTemplate={rowExpansionTemplate}
      onRowEditComplete={onRowEditComplete}
      scrollable={scrollable}
      frozenValue={frozenValue}
      resizableColumns={resizableColumns}
      columnResizeMode={columnResizeMode}
      reorderableColumns={reorderableColumns}
      reorderableRows={reorderableRows}
      onRowReorder={onRowReorder}
      headerColumnGroup={headerColumnGroup}
      onRowClick={onRowClick}
      scrollHeight={scrollHeight}
      tableStyle={tableStyle}
      className={classNames('std-data-table', className)}
    >
      {columns.map((column) => (
        <Column key={column.field} {...column} />
      ))}
    </PrimeReactDataTable>
  );
}
